<template>
  <div class="sectionDataCnt" v-on:click.stop="sectionClicked">
    <draggable v-model="localSectionData" v-on:end="$emit('change', localSectionData)"
      handle=".sectionDh">
      <div class="sectionItem" v-for="(item, i) in localSectionData" :key="`sc${i}`"
        :class="{collapsed: item.collapsed}">
        <div class="sectionTitle" v-on:click="item.collapsed = !item.collapsed">
          <div class="sectionOption" v-on:click.stop="sectionOptions = i"
            :class="{open: sectionOptions === i}">
            <div class="sectionOptions" v-if="sectionOptions === i"
              v-on:click.stop="doNothing">
              <li><div class="icon lock"></div> Unpublish</li>
              <div class="divider"></div>
              <li class="red" v-on:click.stop.prevent="deleteSection(item, i)"
                ><div class="icon delete"></div> Delete Section</li>
            </div>
          </div>
          <div class="sectionDd"></div>
          <div class="sectionDh"></div>
          <h2>{{item.type}}</h2>
        </div>
        <div class="sectionItemWrapper">
          <div class="warning" v-if="item.type === 'Map'">
            Map are free for <b>50.000</b> request per month, and will
            automatically disable after reaching its limit.<br /> please contact developer
            if you need more than <b>50.000</b> request per month.</div>
          <div class="configItem canEdit" v-on:click="editText('id', item.id,
            'Section ID', item, false)">
            <h4>Section ID</h4>
            <p>{{item.id}}</p>
            <div class="helper">Used for customizing section appereances in front-end</div>
          </div>
          <div class="configItem canEdit" v-on:click="editText('title', item.title,
            'Title', item, true)">
            <h4>Title</h4>
            <p>{{item.title[lang]}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('descriptions', item.descriptions,
            'Descriptions', item, true)">
            <h4>Descriptions</h4>
            <p>{{item.descriptions[lang]}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="setColor(item)">
            <h4>Background Color</h4>
            <p :class="{hasColor: item.color}"><span class="color" v-if="item.color"
                :style="{'background-color': item.color}"></span>{{item.color}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('code', item.config.code,
            'Block Code', item.config, true)"
            v-if="item.type === 'Custom Block'">
            <h4>Block Code</h4>
            <p v-if="item.config.code && item.config.code[lang]" class="geojson">
              {{item.config.code[lang].substr(0, 24)}}...{{item.config.code[lang].substr(-4)}}
            </p>
            <p v-else></p>
          </div>
          <template v-if="item.type === 'Map'">
            <div class="configItem canEdit" v-on:click="editText('mapboxStyle',
              item.config.mapboxStyle, 'Mapbox Style', item.config, false)">
              <h4>Mapbox Style</h4>
              <p v-if="item.config.mapboxStyle" class="geojson">
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/actionlab/cl26q3h0m000q14qoa1j4xxza'">Simple Monochrome</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/streets-v12'">Streets</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/outdoors-v12'">Outdoors</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/light-v11'">Light</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/dark-v11'">Dark</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/satellite-v9'">Satellite</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/satellite-streets-v12'">Satellite Streets</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/navigation-day-v1'">Navigation Day</template>
                <template v-if="item.config.mapboxStyle
                  === 'mapbox://styles/mapbox/navigation-night-v1'">Navigation Night</template>
                <template v-if="item.config.mapboxStyle
                  === 'Custom'">Custom</template>
                ({{item.config.mapboxStyle.substr(0, 14)}}...{{item.config.mapboxStyle.substr(-4)}})
              </p>
              <p v-else></p>
              <div class="helper">You can generate custom style on
                <a href="https://www.mapbox.com/mapbox-studio" target="_blank">Mapbox Studio</a>.</div>
            </div>
            <div class="configItem canEdit" v-on:click="editText('zoom', item.config.zoom,
              'Zoom', item.config, false)">
              <h4>Zoom</h4>
              <p>{{item.config.zoom}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="setMapCenter(item)"
              v-if="item.config.lat && item.config.lng">
              <h4>Center</h4>
              <p>{{item.config.lat}}, {{item.config.lng}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('geojson', item.config.geojson,
              'Geo JSON', item.config, false)">
              <h4>Geo JSON</h4>
              <p v-if="item.config.geojson" class="geojson">{{item.config.geojson.substr(0, 40)
                }}...{{item.config.geojson.substr(-4)}}</p>
              <p v-else></p>
              <div class="helper">You can generate Geo JSON on
                <a href="https://www.mapbox.com/mapbox-studio" target="_blank">geojson.io</a>
                and paste geojson here.<br />
                You can add popup dialog to marker by passing <b>title[id]</b> and
                <b>title[en]</b> to GeoJSON parameters.
              </div>
              <button class="helperBtn" v-on:click.stop="viewGeoJsonInfo">
                View available parameters</button>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.wideScreen = !item.config.wideScreen; savePage('draft')">
              <h4>Wide Screen</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.wideScreen}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display map as full screen wide on page
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.interactive = !item.config.interactive; savePage('draft')">
              <h4>Interactive</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.interactive}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Enable user interaction to the map
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.showControl = !item.config.showControl; savePage('draft')">
              <h4>Show Control</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.showControl}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display map controll (zoom in, zoom out, and other controls)
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.fullScreen = !item.config.fullScreen; savePage('draft')">
              <h4>Full Screen Button</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.fullScreen}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display full screen button on top right
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.attribution = !item.config.attribution; savePage('draft')">
              <h4>Attribution Control</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.attribution}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display attribution control on top left
                </div>
              </div>
            </div>
            <div class="configItem canEdit" v-on:click="editText('attributionLabel',
              item.config.attributionLabel, 'Attribution Label', item.config, true)"
              v-if="item.config.attribution">
              <h4>Attribution Label</h4>
              <p>{{item.config.attributionLabel[lang]}}</p>
            </div>
          </template>
          <template v-if="['Form', 'Subscription'].includes(item.type)">
            <div class="configItem configToggle"
              v-on:click="item.config.emailVerification = !item.config.emailVerification;
              savePage('draft')">
              <h4>Email Verification</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.emailVerification}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  <template v-if="item.type === 'Form'">
                    Enable verification if there is email input
                  </template>
                  <template v-else>
                    Enable email verification
                  </template>
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.displayAddress = !item.config.displayAddress;
              savePage('draft')" v-if="item.type === 'Form'">
              <h4>Display Address</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.displayAddress}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display address beside form
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.displaySocmed = !item.config.displaySocmed;
              savePage('draft')" v-if="item.type === 'Form'">
              <h4>Display Social Media</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.displaySocmed}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display social media link?
                </div>
              </div>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.displayNewsletter = !item.config.displayNewsletter;
              savePage('draft')" v-if="item.type === 'Form'">
              <h4>Display Newsletter</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.displayNewsletter}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display subscribe to newsletter button?
                </div>
              </div>
            </div>
            <div class="configItem canEdit" v-on:click="editText('thankYouTitle',
              item.config.thankYouTitle, 'Thank You Title', item.config, true)">
              <h4>Thank You Title</h4>
              <p v-if="item.config.thankYouTitle">{{item.config.thankYouTitle[lang]}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('thankYouDesc',
              item.config.thankYouDesc, 'Thank You Descriptions', item.config, true)">
              <h4>Thank You Descriptions</h4>
              <p v-if="item.config.thankYouDesc">{{item.config.thankYouDesc[lang]}}</p>
            </div>
          </template>
          <template v-if="['Block Articles'].includes(item.type)">
            <div class="configItem canEdit" v-on:click="editText('itemPerPage',
              item.config.itemPerPage, 'Item Per Row', item.config, false)"
              v-if="1>2">
              <h4>Item Per Row</h4>
              <p>{{item.config.itemPerPage}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('displayType',
              item.config.displayType, 'Display Type', item.config, false)">
              <h4>Display Type</h4>
              <p>{{item.config.displayType}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('sources',
              item.config.sources, 'Sources', item.config, false)">
              <h4>Sources</h4>
              <p>{{item.config.sources}}</p>
              <div class="helper" v-if="item.config.sources === 'Auto Selections'">
                Auto selection will take the latest from available data</div>
            </div>
            <div class="configItem canEdit" v-on:click="editText('articleCount',
              item.config.articleCount, 'Display Count', item.config, false)"
              v-if="item.config.sources !== 'Manual Selections'">
              <h4>Display Count</h4>
              <p>{{item.config.articleCount}}</p>
            </div>
          </template>
          <template v-if="['Gallery'].includes(item.type)">
            <div class="configItem canEdit" v-on:click="editText('galleryDisplayType',
              item.config.galleryDisplayType, 'Display Type', item.config, false)">
              <h4>Display Type</h4>
              <p>{{item.config.galleryDisplayType}}</p>
              <div class="helper" v-if="item.config.galleryDisplayType === 'Animated'">
                Animated display type will displaying fixed 12 image item and
                will be animated when user scroll thorough page</div>
              <div class="helper" v-if="item.config.galleryDisplayType === 'Dynamic'">
                Dynamic display type Will be displaying unlimited image</div>
            </div>
          </template>
          <template v-if="['Image Header'].includes(item.type)">
            <div class="configItem canEdit" v-on:click="editText('imgHeaderDisplayType',
              item.config.imgHeaderDisplayType, 'Display Type', item.config, false)">
              <h4>Display Type</h4>
              <p>{{item.config.imgHeaderDisplayType}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('textAlign',
              item.config.textAlign, 'Text Align', item.config, false)">
              <h4>Text Align</h4>
              <p>{{item.config.textAlign}}</p>
            </div>
            <div class="configItem configToggle"
              v-on:click="item.config.showOverlay = !item.config.showOverlay; savePage('draft')">
              <h4>Show Overlay</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.showOverlay}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display overlay above the image
                </div>
              </div>
            </div>
          </template>
          <div class="configItem configToggle"
            v-on:click="item.config.fullScreen = !item.config.fullScreen; savePage('draft')"
            v-if="['Slider', 'Custom Block'].includes(item.type)">
            <h4>Full Screen</h4>
            <div class="toggle">
              <div class="radioItem" :class="{on: item.config.fullScreen}">
                <div class="radioIn">
                  <div class="radioHandle"></div>
                </div>
                Show the slider as full screen page
              </div>
            </div>
          </div>

          <!-- Items -->
          <div class="configItem" v-if="item.type === 'Gallery'">
            <h4>Gallery Items</h4>
            <div class="galleryCnt">
              <div class="galleryItem" v-for="(g, i2) in item.items" :key="`g${i2}`"
                v-on:click="editItem(item, g, i2)">
                <div class="galleryImg" v-if="g && g.imageSm"
                  :style="{'background-image': `url(${g.imageSm})`}"></div>
                <div class="galleryImg noImg" v-else></div>
                <div class="delete" v-on:click.stop="deleteItem(i2, item)"
                  v-if="item.config.galleryDisplayType === 'Dynamic'"></div>
              </div>
              <div class="galleryItem add" v-on:click.stop="addItem(item)"
                v-if="item.config.galleryDisplayType === 'Dynamic'">Add Item</div>
            </div>
          </div>
          <div class="configItem" v-if="['Left Image', 'Right Image',
            'Image Header'].includes(item.type)">
            <h4>Image</h4>
            <div class="galleryCnt">
              <div class="galleryItem">
                <div class="galleryImg" v-if="item.items.length > 0"
                  :style="{'background-image': `url(${item.items[0].imageSm})`}"
                  v-on:click="editItem(item, item.items[0], 0)">
                  <div class="delete" v-on:click.stop="deleteItem(0, item)"></div>
                 </div>
                <div class="galleryImg noImg" v-on:click="addItem(item)" v-else></div>
              </div>
            </div>
          </div>
          <div class="configItem" v-if="item.type === 'Block Articles'
            && item.config.sources === 'Manual Selections'">
            <h4>Articles</h4>
            <div class="galleryCnt">
              <draggable v-model="item.items"
                v-on:end="$emit('change', localSectionData)" class="galleryCnt">
                <div class="galleryItem product" v-for="(s, i2) in item.items"
                  :key="`s${i2}`" v-on:click="editItem(item, s, i2)">
                  <div class="thumb" v-if="s.cover && s.cover[lang]"
                    :style="{'background-image': `url(${s.cover[lang].imageSm})`}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].imageSm"
                    :style="{'background-image': `url(${s.media[lang].imageSm})`}"
                    :class="{png: s.media[lang].mimetype === 'image/png'
                    || s.media[lang].mimetype === 'image/svg+xml'}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].thumb"
                    :style="{'background-image': `url(${s.media[lang].thumb})`}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].mainThumb"
                    :style="{'background-image': `url(${s.media[lang].mainThumb})`}"></div>
                  <div class="thumb" v-else-if="s.thumb && s.thumb[lang]"
                    :style="{'background-image': `url(${s.thumb[lang]})`}"></div>
                  <div class="thumb formField" v-else-if="item.type === 'Form'"
                    :class="s.type"></div>
                  <div class="thumb noImg" v-else></div>
                  <div>
                    <h4 v-if="s.title && s.title[lang]">{{s.title[lang]}}</h4>
                    <h4 v-else-if="s.label && s.label[lang]">{{s.label[lang]}}</h4>
                    <h4 v-else-if="item.type === 'Form' && !s.label[lang]"
                      class="noTitle">No Label</h4>
                    <p v-if="s.descriptions && s.descriptions[lang]">{{s.descriptions[lang]}}</p>
                    <p v-else-if="s.description && s.description[lang]">{{s.description[lang]}}</p>
                    <p v-else-if="s.placeholder && s.placeholder[lang]">{{s.placeholder[lang]}}</p>
                    <p v-else-if="s.url">{{s.url}}</p>
                  </div>
                  <div class="delete" v-on:click.stop="deleteItem(i2, item)"></div>
                </div>
              </draggable>
              <div class="galleryItem product add" v-on:click="addItem(item)">
                Add Item
              </div>
            </div>
          </div>
          <div class="configItem" v-else-if="item.type === 'Block Articles'
            && item.config.sources === 'Directory Contents'">
            <h4>Article Directory</h4>
            <div class="galleryCnt">
              <div class="galleryItem product" v-if="item.config.directory"
                v-on:click="addItem(item)">
                <div class="thumb dir"></div>
                <h4>{{item.config.directory.name[lang]}}</h4>
                <div class="delete" v-on:click.stop="deleteArticleDir(item)"></div>
              </div>
              <div class="galleryItem product add" v-else
                v-on:click="addItem(item)">
                Select Directory
              </div>
            </div>
          </div>

          <div class="configItem" v-if="['Slider', 'Icon Slider',
            'Form', 'Two Image'].includes(item.type)">
            <h4 v-if="item.type === 'Form'">Form Fields</h4>
            <h4 v-else>{{item.type}}s</h4>
            <div class="galleryCnt">
              <draggable v-model="item.items"
                v-on:end="$emit('change', localSectionData)" class="galleryCnt">
                <div class="galleryItem product" v-for="(s, i2) in item.items"
                  :key="`s${i2}`" v-on:click="editItem(item, s, i2)">
                  <div class="thumb" v-if="s.cover && s.cover[lang]"
                    :style="{'background-image': `url(${s.cover[lang].imageSm})`}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].imageSm"
                    :style="{'background-image': `url(${s.media[lang].imageSm})`}"
                    :class="{png: s.media[lang].mimetype === 'image/png'
                    || s.media[lang].mimetype === 'image/svg+xml'}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].thumb"
                    :style="{'background-image': `url(${s.media[lang].thumb})`}"></div>
                  <div class="thumb" v-else-if="s.media && s.media[lang] && s.media[lang].mainThumb"
                    :style="{'background-image': `url(${s.media[lang].mainThumb})`}"></div>
                  <div class="thumb" v-else-if="s.thumb && s.thumb[lang]"
                    :style="{'background-image': `url(${s.thumb[lang]})`}"></div>
                  <div class="thumb formField" v-else-if="item.type === 'Form'"
                    :class="s.type"></div>
                  <div class="thumb noImg" v-else></div>
                  <div>
                    <h4 v-if="s.title && s.title[lang]">{{s.title[lang]}}</h4>
                    <h4 v-else-if="s.label && s.label[lang]">{{s.label[lang]}}</h4>
                    <h4 v-else-if="item.type === 'Form' && !s.label[lang]"
                      class="noTitle">No Label</h4>
                    <p v-if="s.descriptions && s.descriptions[lang]">{{s.descriptions[lang]}}</p>
                    <p v-else-if="s.description && s.description[lang]">{{s.description[lang]}}</p>
                    <p v-else-if="s.placeholder && s.placeholder[lang]">{{s.placeholder[lang]}}</p>
                    <p v-else-if="s.url">{{s.url}}</p>
                  </div>
                  <div class="delete" v-on:click.stop="deleteItem(i2, item)"></div>
                </div>
              </draggable>
              <div class="galleryItem product add" v-on:click="addItem(item)"
                v-if="item.type !== 'Tow Image' || item.items.length < 2">Add Item</div>
            </div>
          </div>
          <template v-if="['Block Articles'].includes(item.type)">
            <div class="configItem configToggle"
              v-on:click="item.config.displayViewAll = !item.config.displayViewAll;
              savePage('draft')">
              <h4>View All Button</h4>
              <div class="toggle">
                <div class="radioItem" :class="{on: item.config.displayViewAll}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Display view all button
                </div>
              </div>
            </div>
            <div class="configItem canEdit" v-on:click="editText('viewAllLabel',
              item.config.viewAllLabel, 'View all label', item.config, true)">
              <h4>View all button label</h4>
              <p>{{item.config.viewAllLabel[lang]}}</p>
            </div>
            <div class="configItem canEdit" v-on:click="editText('viewAllUrl',
              item.config.viewAllUrl, 'View all url', item.config, true)">
              <h4>View all url</h4>
              <p v-if="item.config.viewAllUrl && item.config.viewAllUrl[lang]"
                >{{item.config.viewAllUrl[lang].substr(0, 20)
                }}...{{item.config.viewAllUrl[lang].substr(-4)}}</p>
              <p v-else></p>
            </div>
          </template>
        </div>
      </div>
    </draggable>
    <Confirmation ref="confirmDialog"/>
    <MediaSelector ref="mediaSelector"/>
    <MediaInputer ref="mediaInputer"/>
    <Snackbar ref="snackbar"/>
    <EditorDialog ref="editorDialog"/>
    <AddSlider ref="addSlider"/>
    <AddSocmed ref="addSocmed"/>
    <SectionSelector ref="sectionSelector"/>
    <LoadingDialog ref="loadingDialog"/>
    <AddIconSlider ref="addIconSlider"/>
    <ArticleSelector ref="articleSelector"/>
    <AddForm ref="addForm"/>
    <ColorPicker ref="colorPicker"/>
    <GeoJsonInfo ref="geoJsonInfo"/>
    <ContentDirSelector ref="contentDirSelector"/>
    <AddTwoImage ref="addTwoImage"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import Confirmation from '@/components/Confirmation.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import MediaInputer from '@/components/MediaInputer.vue';
import Snackbar from '@/components/Snackbar.vue';
import EditorDialog from '@/components/EditorDialog.vue';
import AddSlider from '@/components/AddSlider.vue';
import AddSocmed from '@/components/AddSocmed.vue';
import SectionSelector from '@/components/SectionSelector.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import ArticleSelector from '@/components/ArticleSelector.vue';
import AddIconSlider from '@/components/AddIconSlider.vue';
import AddForm from '@/components/AddForm.vue';
import ColorPicker from '@/components/ColorPicker.vue';
import GeoJsonInfo from '@/components/GeoJsonInfo.vue';
import ContentDirSelector from '@/components/ContentDirSelector.vue';
import AddTwoImage from '@/components/AddTwoImage.vue';

export default {
  name: 'sectionData',
  components: {
    draggable,
    Confirmation,
    MediaSelector,
    MediaInputer,
    Snackbar,
    EditorDialog,
    AddSlider,
    AddSocmed,
    SectionSelector,
    LoadingDialog,
    ArticleSelector,
    AddIconSlider,
    AddForm,
    ColorPicker,
    GeoJsonInfo,
    ContentDirSelector,
    AddTwoImage,
  },
  props: ['sectionData'],
  data() {
    return {
      sectionOptions: null,
      localSectionData: this.sectionData,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    sectionClicked() {
      this.sectionOptions = null;
      this.$emit('click');
    },
    deleteSection(item, i) {
      this.sectionOptions = null;
      this.$refs.confirmDialog.open({
        title: `Delete ${item.type} Section`,
        desc: `Are you sure you want to delete this section?
          This operation can not be undone.`,
      }, (b) => {
        if (!b) return;
        this.localSectionData.splice(i, 1);
        this.$emit('change', this.localSectionData);
      });
    },
    setMapCenter(item) {
      this.$refs.confirmDialog.open({
        title: 'Map Center Point',
        desc: 'Input longitude and latitude for map center',
        inputs: [
          {
            type: 'text',
            label: 'Latitude',
            value: { id: item.config.lat },
          },
          {
            type: 'text',
            label: 'Longitude',
            value: { id: item.config.lng },
          },
        ],
        action: 'Set Center',
      }, (b, c, d, v) => {
        item.config.lat = v[0].value.id; // eslint-disable-line
        item.config.lng = v[1].value.id; // eslint-disable-line
      });
    },
    viewGeoJsonInfo() {
      this.$refs.geoJsonInfo.open();
    },
    setColor(item) {
      this.$refs.colorPicker.open({ color: item.color }, (b, color) => {
        if (!b) return;
        item.color = color; // eslint-disable-line
        this.$emit('change', this.localSectionData);
      });
    },
    savePage() {
      this.$emit('change', this.localSectionData);
    },
    editText(fieldName, fieldValue, title, item, multiLang) {
      const options = [];
      const titleLower = title.toLowerCase();
      let fieldType = (titleLower.indexOf('desc') >= 0 || titleLower.indexOf('address') >= 0
        || titleLower.indexOf('note') >= 0 || titleLower.indexOf('info') >= 0) ? 'textarea' : 'text';
      if (fieldName === 'mapboxStyle') {
        fieldType = 'select';
        options.push({ label: 'Simple Monochrome', value: 'mapbox://styles/actionlab/cl26q3h0m000q14qoa1j4xxza' });
        options.push({ label: 'Streets', value: 'mapbox://styles/mapbox/streets-v12' });
        options.push({ label: 'Outdoors', value: 'mapbox://styles/mapbox/outdoors-v12' });
        options.push({ label: 'Light', value: 'mapbox://styles/mapbox/light-v11' });
        options.push({ label: 'Dark', value: 'mapbox://styles/mapbox/dark-v11' });
        options.push({ label: 'Satellite', value: 'mapbox://styles/mapbox/satellite-v9' });
        options.push({ label: 'Satellite Streets', value: 'mapbox://styles/mapbox/satellite-streets-v12' });
        options.push({ label: 'Navigation Day', value: 'mapbox://styles/mapbox/navigation-day-v1' });
        options.push({ label: 'Navigation Night', value: 'mapbox://styles/mapbox/navigation-night-v1' });
        options.push({ label: 'Custom', value: 'Custom' });
      } else if (fieldName === 'displayType') {
        fieldType = 'select';
        options.push({ label: 'Slider', value: 'Slider' });
        options.push({ label: 'Thumbnails', value: 'Thumbnails' });
        options.push({ label: 'List', value: 'List' });
        options.push({ label: 'Events', value: 'Events' });
      } else if (fieldName === 'textAlign') {
        fieldType = 'select';
        options.push({ label: 'Left', value: 'Left' });
        options.push({ label: 'Right', value: 'Right' });
        options.push({ label: 'Center', value: 'Center' });
      } else if (fieldName === 'galleryDisplayType') {
        fieldType = 'select';
        options.push({ label: 'Animated', value: 'Animated' });
        options.push({ label: 'Dynamic', value: 'Dynamic' });
      } else if (fieldName === 'imgHeaderDisplayType') {
        fieldType = 'select';
        options.push({ label: 'Croped', value: 'Croped' });
        options.push({ label: 'Full', value: 'Full' });
      } else if (fieldName === 'sources') {
        fieldType = 'select';
        options.push({ label: 'Auto Selections', value: 'Auto Selections' });
        options.push({ label: 'Manual Selections', value: 'Manual Selections' });
        options.push({ label: 'Directory Contents', value: 'Directory Contents' });
      }
      if (['geojson', 'code'].includes(fieldName)) fieldType = 'long-textarea';
      this.$refs.mediaInputer.open({
        title,
        options,
        placeholder: title,
        type: fieldType,
        model: fieldValue,
        action: 'Save Changes',
        multiLang,
      }, (b, v) => {
        if (!b) return;
        item[fieldName] = v; // eslint-disable-line
        this.$emit('change', this.localSectionData);
      });
    },
    deleteArticleDir(section) {
      this.$refs.confirmDialog.open({
        title: 'Delete Item',
        desc: 'Are you sure you want to delete this item?',
      }, (b) => {
        if (!b) return;
        section.config.directory = null; // eslint-disable-line
        this.$emit('change', this.localSectionData);
      });
    },
    deleteItem(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Item',
        desc: 'Are you sure you want to delete this item?',
      }, (b) => {
        if (!b) return;
        item.items.splice(i, 1);
        this.$emit('change', this.localSectionData);
      });
    },
    addItem(section) {
      let dialog;
      let options = null;
      switch (section.type) {
        case 'Slider':
          dialog = this.$refs.addSlider;
          break;
        case 'Icon Slider':
          dialog = this.$refs.addIconSlider;
          break;
        case 'Two Image':
          dialog = this.$refs.addTwoImage;
          break;
        case 'Block Articles':
          dialog = (section.config.sources === 'Directory Contents')
            ? this.$refs.contentDirSelector : this.$refs.articleSelector;
          break;
        case 'Gallery':
        case 'Right Image':
        case 'Left Image':
        case 'Image Header':
          dialog = this.$refs.mediaSelector;
          options = { type: 'image' };
          break;
        case 'Form':
          dialog = this.$refs.addForm;
          break;
        default: break;
      }
      if (!dialog) return;
      dialog.open(options, (b, v) => {
        if (!b) return;
        if (['Gallery', 'Right Image', 'Left Image', 'Image Header'].includes(section.type)) {
          const m = (v.gallery) ? v.gallery[0] : v;
          if (m.type !== 'image') {
            this.$refs.confirmDialog.open({
              title: 'Media Not Supported',
              desc: 'Only support image media for this section itm',
              error: true,
            });
            return;
          }
          if (v.gallery) {
            section.items.push(...v.gallery);
          } else {
            section.items.push(m);
          }
        } else if (section.type === 'Block Articles'
          && section.config.sources === 'Directory Contents') {
          section.config.directory = v; // eslint-disable-line
        } else {
          section.items.push(v);
        }
        this.$emit('change', this.localSectionData);
      });
    },
    editItem(section, item, i) {
      let dialog;
      let options = null;
      switch (section.type) {
        case 'Slider':
          dialog = this.$refs.addSlider;
          break;
        case 'Icon Slider':
          dialog = this.$refs.addIconSlider;
          break;
        case 'Two Image':
          dialog = this.$refs.addTwoImage;
          break;
        case 'Block Articles':
          dialog = this.$refs.articleSelector;
          break;
        case 'Gallery':
        case 'Right Image':
        case 'Left Image':
        case 'Image Header':
          options = { type: 'image' };
          dialog = this.$refs.mediaSelector;
          break;
        case 'Form':
          dialog = this.$refs.addForm;
          break;
        default: break;
      }
      if (!dialog) return;
      dialog.open(options || item, (b, v) => {
        if (!b) return;
        if (['Gallery', 'Right Image', 'Left Image', 'Image Header'].includes(section.type)) {
          const m = (v.gallery) ? v.gallery[0] : v;
          if (m.type !== 'image') {
            this.$refs.confirmDialog.open({
              title: 'Media Not Supported',
              desc: 'Only support image media for this section itm',
              error: true,
            });
            return;
          }
          section.items.splice(i, 1, m);
        } else {
          section.items.splice(i, 1, v);
        }
        this.$emit('change', this.localSectionData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.sectionItem{
  margin-top: 20px;
  padding: 0 0 16px;
  &.sortable-ghost{
    background-color: #eee !important;
    *{
      opacity: 0;
    }
  }
  &.sortable-chosen{
    background-color: #eee !important;
  }
  &.sortable-drag{
    background-color: #fff !important;
  }
  .sectionTitle{
    position: relative;
    border-bottom: #eee 1px solid;
    cursor: pointer;
    h2{
      margin: 0;
      padding: 10px 40px;
      font-size: 22px;
      font-weight: 600;
    }
    &:hover{
      // background-color: #f5f5f5;
    }
    .sectionOption{
      width: 34px; height: 34px;
      position: absolute;
      right: 30px; top: 8px;
      border-radius: 50%;
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .56;
      background-image: url(../assets/more.png);
      cursor: pointer;
      transition: background-color .3s ease;
      &.open{
        opacity: 1;
      }
      &:hover{
        background-color: #eee;
      }
      .sectionOptions{
        position: absolute;
        background-color: #fff;
        z-index: 7;
        padding: 8px 0;
        border-radius: 5px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .2);
        right: 100%; top: 0;
        .divider{
          height: 1px;
          background-color: #eee;
          margin: 5px 0;
        }
        li{
          margin: 0;
          border-radius: 0;
          list-style: none;
          font-size: 15px;
          white-space: nowrap;
          padding: 8px 24px;
          padding-left: 16px;
          cursor: pointer;
          transition: all .3s ease;
          display: flex;
          align-items: center;
          &.red{
            color: red;
          }
          .icon{
            width: 18px; height: 18px;
            margin-right: 10px;
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
            &.link{
              background-image: url(../assets/external-link-black.png);
              background-size: 16px auto;
              opacity: .65;
            }
            &.delete{
              background-image: url(../assets/delete.png);
            }
            &.lock{
              background-image: url(../assets/private-o.png);
              background-size: 18px auto;
            }
            &.edit{
              background-image: url(../assets/edit-black.png);
              background-size: 15px auto;
              opacity: .76;
            }
            &.main{
              background-image: url(../assets/crown-black.png);
              background-size: 15px auto;
              opacity: .64;
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
    .sectionDh{
      width: 34px; height: 34px;
      position: absolute;
      left: 6px; top: 8px;
      border-radius: 50%;
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .65;
      background-image: url(../assets/drag-and-drop.png);
      cursor: pointer;
      transition: all .3s ease;
    }
    .sectionDd{
      width: 34px; height: 34px;
      position: absolute;
      right: 68px; top: 8px;
      border-radius: 50%;
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .45;
      background-image: url(../assets/down-arrow.png);
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #eee;
      }
    }
  }
  .sectionItemWrapper{
    transition: all .3s ease;
    .warning{
      background-color: #fff7db;
      padding: 10px 20px;
      color: #705700;
      border-bottom: #f5edd0 1px solid;
      line-height: 1.14;
    }
  }
  &.collapsed{
    padding-bottom: 0;
    .sectionTitle{
      .sectionDd{
        transform: rotate(180deg);
      }
    }
    .sectionItemWrapper{
      display: none;
    }
  }
}
.configItem{
  padding: 12px 40px;
  position: relative;
  &.configToggle{
    padding-bottom: 20px;
  }
  &.canEdit{
    cursor: pointer;
    transition: background-color .3s ease;
    &:before{
      content: "";
      position: absolute;
      left: 12px; top: 28px;
      width: 20px; height: 20px;
      background-image: url(../assets/edit-black.png);
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .56;
    }
    &:hover{
      background-color: #f5f5fe;
    }
  }
  .toggle{
    padding-top: 6px;
    .radioItem{
      padding-left: 60px;
    }
  }
  .helperBtn{
    color: #0e5dd2;
    background-color: #fff;
    border: #0e5dd2 1px solid;
    padding: 6px 14px;
    font-size: 14px;
    border-radius: 50px;
    margin: 6px 0 0;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  .helper{
    color: #767676;
    font-size: 13px;
    margin: 4px 0 0;
  }
  h4{
    margin: 0;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    color: #888;
  }
  p{
    margin: 0;
    white-space: pre-wrap;
    line-height: 1.3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
            line-clamp: 3;
    -webkit-box-orient: vertical;
    &.geojson{
      white-space: normal;
    }
    &.hasColor{
      position: relative;
      padding-left: 26px;
      margin-top: 4px;
      span.color{
        position: absolute;
        width: 20px; height: 20px;
        border-radius: 3px;
        left: 0; top: 0;
        box-sizing: border-box;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
    }
    &:empty::before {
      content: 'Not set';
      color: #999;
      font-style: italic;
    }
  }
  .features{
    display: flex;
    padding: 6px 0 0;
    .featureItem{
      border-radius: 5px;
      border: #eee 1px solid;
      margin: 0 10px 0 0;
      padding: 10px 14px;
      box-sizing: border-box;
      width: 200px;
      h4{
        font-size: 17px;
        font-weight: normal;
        text-transform: none;
        color: #444;
        margin: 0 0 4px;
      }
      p{
        font-size: 14px;
        color: #767676;
      }
    }
  }
  .numberCnt{
    display: flex;
    flex-wrap: wrap;
    padding: 6px 0 0;
    margin-bottom: -10px;
    .numberItem{
      border-radius: 5px;
      border: #eee 1px solid;
      margin: 0 10px 10px 0;
      padding: 10px 14px 16px;
      // text-align: center;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      min-height: 40px;
      h4{
        font-size: 24px;
        font-weight: 600;
        color: #444;
        text-transform: none;
        white-space: nowrap;
        margin: 0;
      }
      p{
        font-size: 13px;
        white-space: nowrap;
        margin: 0;
        color: #767676;
      }
      .delete{
        content: "";
        position: absolute;
        right: -8px; top: -8px;
        width: 20px; height: 20px;
        background-image: url(../assets/close-white.png);
        background-color: red;
        border-radius: 50%;
        background-size: 8px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: all .3s ease;
        opacity: .8;
        &:hover{
          opacity: 1;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
      }
      &:hover{
        background-color: #f5f5fe;
      }
      &.add{
        background-color: #eee;
        color: #999;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all .3s ease;
        line-height: 0;
        padding: 0 20px;
        .delete{
          display: none;
        }
        &:hover{
          background-color: #ddd;
          color: #767676;
        }
      }
      &.support{
        text-align: left;
        height: 68px;
        h4{
          font-size: 17px;
        }
        p{
          font-size: 15px;
        }
      }
    }
  }
  .galleryCnt{
    display: flex;
    padding: 6px 0 0;
    flex-wrap: wrap;
    margin-bottom: -10px;
    .galleryCnt{
      padding: 0;
      margin: 0;
    }
    &.dataAuto{
      color: #767676;
      font-style: italic;
    }
    .galleryItem{
      margin: 0 10px 10px 0;
      width: 120px; height: 80px;
      background-color: #eee;
      border-radius: 5px;
      position: relative;
      background-size: cover;
      background-position: center;
      transition: all .3s ease;
      box-sizing: border-box;
      &:hover{
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
      .galleryImg{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        border-radius: 5px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: opacity .3s ease;
        cursor: pointer;
        &.noImg{
          background-size: 36px auto;
          background-image: url(../assets/photo-black.png);
          opacity: .36;
          &:hover{
            opacity: .46;
          }
        }
      }
      .delete{
        position: absolute;
        right: -8px; top: -8px;
        width: 20px; height: 20px;
        background-image: url(../assets/close-white.png);
        background-color: red;
        border-radius: 50%;
        background-size: 8px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: all .3s ease;
        opacity: 1;
        &:hover{
          opacity: 1;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
      }
      &.add{
        background-color: #eee;
        color: #999;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all .3s ease;
        line-height: 0;
        padding: 0 20px;
        &:hover{
          background-color: #ddd;
          color: #767676;
        }
      }
      &.banner{
        height: 60px;
        cursor: pointer;
      }
      &.invLogo{
        height: 120px;
        cursor: pointer;
        background-size: contain;
        background-repeat: no-repeat;
        &.add{
          padding: 0;
        }
      }
      &.product{
        width: auto;
        height: auto;
        min-height: 54px;
        background-color: #fff;
        border: #eee 1px solid;
        padding: 6px 20px;
        padding-left: 60px;
        box-sizing: border-box;
        cursor: pointer;
        max-width: 260px;
        display: flex;
        align-items: center;
        h4{
          text-transform: none;
          font-size: 16px;
          font-weight: 600;
          color: #444;
          margin: 0;
          padding-right: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 140px;
          display: block;
          &.noTitle{
            color: #999;
            font-style: italic;
          }
        }
        p{
          margin: -1px 0 0;
          font-size: 14px;
          color: #767676;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 160px;
          display: block;
        }
        &.add{
          background-color: #eee;
          padding: 0 20px;
        }
        .thumb{
          left: 8px;
          top: 6px;
          position: absolute;
          width: 40px;
          height: 40px;
          background-color: #e5e5e5;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 4px;
          opacity: 1;
          display: inline-block;
          box-sizing: border-box;
          &.dir{
            background-image: url(../assets/directory.png);
            background-size: 62%;
            background-color: #fff;
            opacity: .76;
          }
          &.png{
            background-size: 68%;
            background-color: #fff;
          }
          &.formField{
            background-color: transparent;
            background-size: 22px auto;
            background-position: center;
            opacity: .56;
            &.text{
              background-image: url(../assets/short-text.png);
            }
            &.textarea{
              background-image: url(../assets/long-text.png);
            }
            &.select{
              background-image: url(../assets/dropdown.png);
            }
            &.checkbox{
              background-image: url(../assets/checkbox.png);
            }
            &.date{
              background-image: url(../assets/calendar.png);
            }
          }
          &.noImg{
            background-color: #ccc;
            opacity: .36;
            background-image: url(../assets/image-black.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
.sectionDataCnt.fromArticle{
  margin: 0;
  padding: 0;
  .sectionItem{
    border: #eee 1px solid;
    border-radius: 5px;
    margin-top: 10px;
    .sectionOption{
      right: 10px;
    }
    .sectionDd{
      right: 48px;
    }
  }
}
</style>
